import { logger } from '../components/Debug/DebugLogging';
export const logAction = (state, action) => {
  if (typeof process !== 'undefined' && (!process || !process.env || process.env.NODE_ENV !== 'test')) {
    logger.group('Dispatch');
    logger.log('Action:', action);
    logger.log('State:', state);
    logger.groupEnd();
  }
};